import { Navigate } from 'react-router-dom'

// AI Studio index redirects to Agents page
export default function AIStudioIndex() {
  return <Navigate to="/ai-studio/agents" replace />
}
